import styled from "styled-components";

export const StyledSnakeGame = styled.div`
    background: #333;
    height: 100vh;
    width: 100vw;
    display: grid;
    justify-content: center;
    align-content: space-evenly;
`;